<template>
    <div class="card">
        <header class="card-header">
            <p class="card-header-title">You Have an Open {{ capitalize(type) }}</p>
        </header>
        <div class="card-content">
            <div class="content">
                <p>
                    You cannot start this {{ capitalize(currentType) }} until your open {{ capitalize(type) }} has been
                    completed. Please finish your {{ capitalize(type) }} before beginning a new
                    {{ capitalize(currentType) }}.
                </p>
            </div>

            <e-field class="buttons" grouped position="is-right">
                <e-button type="is-primary is-outlined" @click="cancel">Go Back</e-button>
                <e-button type="is-primary" @click="resumeAttempt">Resume {{ capitalize(type) }}</e-button>
            </e-field>
        </div>
    </div>
</template>

<script>
import capitalize from 'lodash/capitalize.js';

import { handleResponseError } from '@/Helpers.js';
import axios from '@/plugins/axios.js';
import QueryBuilder from '@/utilities/QueryBuilder.js';

export default {
    name: 'QuizInProgressModal',

    props: {
        quizAttempt: {
            type: Object,
            default: null,
        },

        currentType: {
            type: String,
            default: null,
        },
    },

    emits: ['close'],

    computed: {
        type() {
            if (this.quizAttempt?.automated_survey_assignment) {
                return 'survey';
            }

            return this.quizAttempt.quiz_activity_id ? 'quiz' : 'survey';
        },

        modelActivity() {
            return this.quizAttempt[`${this.type}_activity`];
        },

        activityId() {
            if (this.quizAttempt?.automated_survey_assignment) {
                return this.quizAttempt.automated_survey_assignment.activity_id;
            }

            return this.modelActivity.activity.id;
        },

        courseId() {
            if (this.quizAttempt?.automated_survey_assignment) {
                return this.quizAttempt.automated_survey_assignment.course_id;
            }

            return this.modelActivity.activity.course_id;
        },

        activityPage() {
            return {
                name: 'activity-view',
                params: {
                    activityId: this.activityId,
                    courseId: this.courseId,
                },
            };
        },
    },

    methods: {
        capitalize,

        cancel() {
            this.$emit('close');
        },

        async endQuizAttempts() {
            const queryBuilder = new QueryBuilder(`quiz-attempts/${this.quizAttempt.id}`);

            const payload = {
                end_time: this.$moment().utc().format('YYYY-MM-DD HH:mm:ss'),
            };

            await axios.put(queryBuilder.toUrl(), payload, { errorHandle: false }).catch(e => {
                handleResponseError(e);
            });

            this.cancel();

            this.$router.go();
        },

        resumeAttempt() {
            this.cancel();

            if (this.quizAttempt.automated_survey_assignment) {
                const automatedAttempt = this.quizAttempt.automated_survey_assignment;

                this.$router.push({
                    name: 'automated-survey-attempt',
                    params: {
                        id: automatedAttempt.survey_id,
                        assignmentId: automatedAttempt.id,
                        attemptId: automatedAttempt.survey_attempt_id,
                    },
                });

                return;
            }

            this.$router.push({
                name: 'quiz-attempt',
                params: {
                    activityId: Number(this.activityId),
                    courseId: Number(this.courseId),
                    id: Number(this.modelActivity.quiz_id),
                    attemptId: Number(this.quizAttempt.id),
                },
            });
        },
    },
};
</script>
